module.exports = __webpack_public_path__ + "img/loginBg.a17cff79.jpg";